import { render, staticRenderFns } from "./StatisticUser.vue?vue&type=template&id=6abe9318"
import script from "./StatisticUser.vue?vue&type=script&lang=js"
export * from "./StatisticUser.vue?vue&type=script&lang=js"
import style0 from "./StatisticUser.vue?vue&type=style&index=0&id=6abe9318&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports